export default __webpack_public_path__ + "static/media/story_catch_phrase.5e5afa11.png";